import { Slider } from '@mantine/core';

import classes from './index.module.css';

interface ICalculatorSlider {
  color?: string;
  disabled?: boolean;
  max: number;
  min: number;
  step: number;
}

const CalculatorSlider = ({
  color = '#2C5218',
  disabled,
  max,
  min,
  step,
  ...props
}: ICalculatorSlider) => {
  return (
    <Slider
      classNames={{
        thumb: classes.thumb,
        bar: classes.bar,
        track: classes.track
      }}
      color={color}
      min={min}
      max={max}
      step={step}
      mt={10}
      disabled={disabled}
      {...props}
    />
  );
}

export default CalculatorSlider;